export var dscrLoan = {
    "dscr-loan": {
        "id": "15823-df-www",
        "dynamicform": "https://www.newamericanfunding.com/lp/df/dscr-loan/",
        "templateType": "standard",
        "layout": {
            "templateType": "standard",
            "navGroups": []
        },
        "pages": [
            "15823_loanPurpose"
        ],
        "subFlows": {
            "purchase": {
                "path": "https://www.newamericanfunding.com/lp/df/dscr-loan/#15823_purchase",
                "visible": [
                    "equal",
                    "loanPurpose",
                    "purchase"
                ],
                "pages": [
                    "15823_loanPurpose",
                    "15886_occupancy",
                    "15887_propertyAddress",
                    "15892_loanAmt_P",
                    "15888_estimateCreditRating",
                    "15890_liquidity",
                    "15885_fullName",
                    "15889_email",
                    "15891_Phone"
                ]
            },
            "refinance": {
                "path": "https://www.newamericanfunding.com/lp/df/dscr-loan/#15823_refinance",
                "visible": [
                    "equal",
                    "loanPurpose",
                    "refinance"
                ],
                "pages": [
                    "15823_loanPurpose",
                    "15901_occupancy",
                    "15895_propertyAddress",
                    "15894_homeValueAmt",
                    "15896_estimateCreditRating",
                    "15899_liquidity",
                    "15898_fullName",
                    "15897_email",
                    "15900_Phone"
                ]
            },
            "cashout": {
                "path": "https://www.newamericanfunding.com/lp/df/dscr-loan/#15823_cashout",
                "visible": [
                    "equal",
                    "loanPurpose",
                    "cashout"
                ],
                "pages": [
                    "15823_loanPurpose",
                    "15868_occupancy",
                    "15862_propertyAddress",
                    "15863_homeValueAmt",
                    "15864_estimateCreditRating",
                    "15867_liquidity",
                    "15866_fullName",
                    "15865_email",
                    "15869_Phone"
                ]
            }
        },
        "templateCollection": {
            "NAF_HomePage": "root",
            "NAF_DynamicForm": "parent",
            "NAF_DynamicFormStandardPage": "standard",
            "NAF_DynamicFormLeftNavPage": "leftnav"
        },
        "pageCollection": {
            "15823_loanPurpose": {
                "title": "Are you buying, refinancing, or pulling cash out?",
                "subtext": "Let us know your goal so we can find the right fit.",
                "questions": [
                    "loanPurpose"
                ],
                "category": ""
            },
            "15886_occupancy": {
                "title": "Investment property, or home you plan on living in?*",
                "subtext": null,
                "questions": [
                    "15886_occupancy"
                ]
            },
            "15887_propertyAddress": {
                "title": "What is the property address?",
                "subtext": "Depending on location we may have specific programs",
                "questions": [
                    "15887_propertyAddress"
                ]
            },
            "15892_loanAmt_P": {
                "title": "What is the estimated purchase price?",
                "subtext": "Our minimum loan amount is $75,000 up to $20,000,000",
                "questions": [
                    "15892_loanAmt_P"
                ]
            },
            "15888_estimateCreditRating": {
                "title": "How would you rate your credit?",
                "subtext": "We do not lend on credit scores below 660",
                "questions": [
                    "15888_estimateCreditRating"
                ]
            },
            "15890_liquidity": {
                "title": "What is your current liquidity?",
                "subtext": null,
                "questions": [
                    "15890_liquidity"
                ]
            },
            "15885_fullName": {
                "title": "Legal first and last name of the primary borrower?",
                "subtext": null,
                "questions": [
                    "15885_firstName",
                    "15885_lastName"
                ]
            },
            "15889_email": {
                "title": "What is your e-mail address?",
                "subtext": "We adhere to a strict privacy policy and will never sell your information.",
                "questions": [
                    "15889_email"
                ]
            },
            "15891_Phone": {
                "title": "What is your phone number?",
                "subtext": null,
                "questions": [
                    "15891_phone"
                ]
            },
            "15901_occupancy": {
                "title": "Investment property, or home you plan on living in?*",
                "subtext": "We do not fund owner occupied assets",
                "questions": [
                    "15901_occupancy"
                ]
            },
            "15895_propertyAddress": {
                "title": "What is the property address?",
                "subtext": "Depending on location we may have specific programs",
                "questions": [
                    "15895_propertyAddress"
                ]
            },
            "15894_homeValueAmt": {
                "title": "What's the Refinance amount?",
                "subtext": "Our minimum loan amount is $75,000 up to $20,000,000",
                "questions": [
                    "15894_homeValueAmt"
                ]
            },
            "15896_estimateCreditRating": {
                "title": "How is your credit?*",
                "subtext": "We do not lend on credit scores below 660",
                "questions": [
                    "15896_estimateCreditRating"
                ]
            },
            "15899_liquidity": {
                "title": "Whats your current liquidity?",
                "subtext": null,
                "questions": [
                    "15899_liquidity"
                ]
            },
            "15898_fullName": {
                "title": "Legal first and last name of the primary borrower?",
                "subtext": null,
                "questions": [
                    "15898_firstName",
                    "15898_lastName"
                ]
            },
            "15897_email": {
                "title": "What is your email address?",
                "subtext": "Your email address will be protected. No Spam",
                "questions": [
                    "15897_email"
                ]
            },
            "15900_Phone": {
                "title": "Mobile phone number?*",
                "subtext": null,
                "questions": [
                    "15900_phone"
                ]
            },
            "15868_occupancy": {
                "title": "Investment property, or home you plan on living in?*",
                "subtext": null,
                "questions": [
                    "15868_occupancy"
                ]
            },
            "15862_propertyAddress": {
                "title": "What is the property address?",
                "subtext": "Depending on location we may have specific programs",
                "questions": [
                    "15862_propertyAddress"
                ]
            },
            "15863_homeValueAmt": {
                "title": "What's the Refinance amount?",
                "subtext": "Our minimum loan amount is $75,000 up to $20,000,000",
                "questions": [
                    "15863_homeValueAmt"
                ]
            },
            "15864_estimateCreditRating": {
                "title": "How would you rate your credit?",
                "subtext": "We do not lend on credit scores below 660",
                "questions": [
                    "15864_estimateCreditRating"
                ]
            },
            "15867_liquidity": {
                "title": "What is your current liquidity?",
                "subtext": null,
                "questions": [
                    "15867_liquidity"
                ]
            },
            "15866_fullName": {
                "title": "Legal first and last name of the primary borrower?",
                "subtext": "Your identity will be protected. No spam",
                "questions": [
                    "15866_firstName",
                    "15866_lastName"
                ]
            },
            "15865_email": {
                "title": "What is your e-mail address?",
                "subtext": "We adhere to a strict privacy policy and will never sell your information.",
                "questions": [
                    "15865_email"
                ]
            },
            "15869_Phone": {
                "title": "What is your phone number?",
                "subtext": null,
                "disclosure": "**By entering my phone number above, I agree to receive recurring automated text messages at the phone number provided. Consent is not a condition to purchase. Msg &amp; data rates may apply. Msg frequency varies.",
                "hideDisclosure": true,
                "questions": [
                    "15869_phone"
                ]
            }
        },
        "questionCollection": {
            "15886_occupancy": {
                "type": "radio",
                "fieldId": "occupancy",
                "answerOptions": [
                    {
                        "text": "Investment Property",
                        "value": "Investment Property",
                        "imageUrl": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/6676711.699a51de61e590.53671863.png"
                    },
                    {
                        "text": "Owner Occupied",
                        "value": "Owner Occupied",
                        "imageUrl": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/3458194.699a520a0e7524.72727590.png"
                    }
                ]
            },
            "15887_propertyAddress": {
                "type": "autoAddressMultifield",
                "fieldId": "propertyAddress",
                "required": true,
                "notNY": false,
                "autoComplete": "on",
                "hideDisclosure": false
            },
            "15892_loanAmt_P": {
                "type": "inputText",
                "inputType": "currency",
                "fieldId": "loanAmt_P",
                "questionTitle": "What is the estimated purchase price?",
                "includeSlider": false,
                "validation": [
                    [
                        "min",
                        75000,
                        "Min: $75,000"
                    ],
                    [
                        "max",
                        20000000,
                        "Max: $20,000,000"
                    ]
                ]
            },
            "15888_estimateCreditRating": {
                "type": "radio",
                "fieldId": "estimateCreditRating",
                "answerOptions": [
                    {
                        "text": "Excellent (720+)",
                        "value": "Excellent (720+)",
                        "imageUrl": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/22.HCL-Star4.60ee173c638c24.16001568.png"
                    },
                    {
                        "text": "Good (680 – 719)",
                        "value": "Good (680 – 719)",
                        "imageUrl": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/21.HCL-Star3.60ee17372ec1d7.94917995.png"
                    },
                    {
                        "text": "Fair (620 – 679)",
                        "value": "Fair (620 – 679)",
                        "imageUrl": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/20.HCL-Star2.60ee1732e00a27.57474386.png"
                    },
                    {
                        "text": "Poor (580 - 619)",
                        "value": "Poor (580 - 619)",
                        "imageUrl": "https://files.jotform.com/jufs/Roberts_Ryan_ryan%2Fform_files%2F19.HCL-Star1.60ee172e1996d5.15114805.png?md5=JaKuL58UaX5RA_D0ulnOpg&expires=1771605309"
                    },
                    {
                        "text": "Below < 580",
                        "value": "Below < 580",
                        "imageUrl": "https://files.jotform.com/jufs/Roberts_Ryan_ryan%2Fform_files%2F19.HCL-Star1.60ee172e1996d5.15114805.png?md5=JaKuL58UaX5RA_D0ulnOpg&expires=1771605309"
                    }
                ]
            },
            "15890_liquidity": {
                "type": "radio",
                "fieldId": "liquidity",
                "answerOptions": [
                    {
                        "text": "No liquidity",
                        "value": "No liquidity"
                    },
                    {
                        "text": "Less than $25k",
                        "value": "Less than $25k"
                    },
                    {
                        "text": "$25k to $50k",
                        "value": "$25k to $50k"
                    },
                    {
                        "text": "$50k to $100k",
                        "value": "$50k to $100k"
                    },
                    {
                        "text": "More than $100k",
                        "value": "More than $100k"
                    },
                    {
                        "text": "Other",
                        "value": "Other"
                    }
                ]
            },
            "15885_firstName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "firstName",
                "name": "Textbox | First Name",
                "label": "First Name",
                "placeholder": "Enter first name",
                "autoComplete": "given-name",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 2,
                "maxLength": 50,
                "pattern": "^[A-Za-z]{2}[A-Za-z -]*$",
                "hideDisclosure": false,
                "validation": [
                    [
                        "required",
                        "First Name required"
                    ],
                    [
                        "pattern",
                        "^[A-Za-z]{2}[A-Za-z -]*$",
                        "Must start with two letters. Only letters, spaces and hyphens are allowed."
                    ],
                    [
                        "minLength",
                        2,
                        "Min 2 letters"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 letters"
                    ]
                ]
            },
            "15885_lastName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "lastName",
                "name": "Textbox | Last Name",
                "label": "Last Name",
                "placeholder": "Enter last name",
                "autoComplete": "family-name",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 2,
                "maxLength": 50,
                "pattern": "^[A-Za-z]{2}[A-Za-z -]*$",
                "hideDisclosure": false,
                "validation": [
                    [
                        "required",
                        "Last Name required"
                    ],
                    [
                        "pattern",
                        "^[A-Za-z]{2}[A-Za-z -]*$",
                        "Must start with two letters. Only letters, spaces and hyphens are allowed."
                    ],
                    [
                        "minLength",
                        2,
                        "Min 2 letters"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 letters"
                    ]
                ]
            },
            "15885_fullName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "fullName",
                "hideDisclosure": false
            },
            "15889_email": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "email",
                "name": "Textbox | Email Address",
                "label": "Email Address",
                "placeholder": "Enter email address",
                "autoComplete": "email",
                "autoCorrect": "off",
                "spellCheck": "false",
                "maxLength": 50,
                "pattern": "^[a-zA-Z0-9_+-](?:[a-zA-Z0-9._+-])*@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
                "hideDisclosure": false,
                "validation": [
                    [
                        "required",
                        "Email Address required"
                    ],
                    [
                        "pattern",
                        "^[a-zA-Z0-9_+-](?:[a-zA-Z0-9._+-])*@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
                        "Invalid Email Address"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 characters"
                    ]
                ]
            },
            "15891_phone": {
                "type": "inputText",
                "inputType": "tel",
                "fieldId": "phone",
                "name": "Textbox | Phone Number",
                "label": "Phone Number**",
                "labelAlt": "Phone Number",
                "placeholder": "(___) ___-____",
                "inputMask": "(999) 999-9999",
                "autoComplete": "tel-national",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 14,
                "maxLength": 14,
                "pattern": "[(][^01].*",
                "hideDisclosure": false,
                "validation": [
                    [
                        "required",
                        "Phone number is required"
                    ],
                    [
                        "pattern",
                        "[(][^01].*",
                        "Phone area code invalid"
                    ],
                    [
                        "minLength",
                        14,
                        "10-Digit Phone #"
                    ],
                    [
                        "maxLength",
                        14
                    ],
                    [
                        "phone"
                    ]
                ]
            },
            "15891_Phone": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "Phone",
                "hideDisclosure": false
            },
            "15901_occupancy": {
                "type": "radio",
                "fieldId": "occupancy",
                "answerOptions": [
                    {
                        "text": "Investment Property",
                        "value": "Investment Property",
                        "imageUrl": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/6676711.699a51de61e590.53671863.png"
                    },
                    {
                        "text": "Owner Occupied",
                        "value": "Owner Occupied",
                        "imageUrl": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/3458194.699a520a0e7524.72727590.png"
                    }
                ]
            },
            "15895_propertyAddress": {
                "type": "autoAddressMultifield",
                "fieldId": "propertyAddress",
                "required": true,
                "notNY": false,
                "autoComplete": "on",
                "hideDisclosure": false
            },
            "15894_homeValueAmt": {
                "type": "inputText",
                "inputType": "currency",
                "fieldId": "homeValueAmt",
                "questionTitle": "What's the Refinance amount?",
                "includeSlider": false,
                "validation": [
                    [
                        "min",
                        75000,
                        "Min: $75,000"
                    ],
                    [
                        "max",
                        20000000,
                        "Max: $20,000,000"
                    ]
                ]
            },
            "15896_estimateCreditRating": {
                "type": "radio",
                "fieldId": "estimateCreditRating",
                "answerOptions": [
                    {
                        "text": "Excellent (720+)",
                        "value": "Excellent (720+)",
                        "imageUrl": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/22.HCL-Star4.60ee173c638c24.16001568.png"
                    },
                    {
                        "text": "Good (680 – 719)",
                        "value": "Good (680 – 719)",
                        "imageUrl": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/21.HCL-Star3.60ee17372ec1d7.94917995.png"
                    },
                    {
                        "text": "Fair (620 – 679)",
                        "value": "Fair (620 – 679)",
                        "imageUrl": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/20.HCL-Star2.60ee1732e00a27.57474386.png"
                    },
                    {
                        "text": "Poor (580 - 619)",
                        "value": "Poor (580 - 619)",
                        "imageUrl": "https://files.jotform.com/jufs/Roberts_Ryan_ryan%2Fform_files%2F19.HCL-Star1.60ee172e1996d5.15114805.png?md5=JaKuL58UaX5RA_D0ulnOpg&expires=1771605309"
                    },
                    {
                        "text": "Below < 580",
                        "value": "Below < 580",
                        "imageUrl": "https://files.jotform.com/jufs/Roberts_Ryan_ryan%2Fform_files%2F19.HCL-Star1.60ee172e1996d5.15114805.png?md5=JaKuL58UaX5RA_D0ulnOpg&expires=1771605309"
                    }
                ]
            },
            "15899_liquidity": {
                "type": "radio",
                "fieldId": "liquidity",
                "answerOptions": [
                    {
                        "text": "No liquidity",
                        "value": "No liquidity"
                    },
                    {
                        "text": "Less than $25k",
                        "value": "Less than $25k"
                    },
                    {
                        "text": "$25k to $50k",
                        "value": "$25k to $50k"
                    },
                    {
                        "text": "$50k to $100k",
                        "value": "$50k to $100k"
                    },
                    {
                        "text": "More than $100k",
                        "value": "More than $100k"
                    },
                    {
                        "text": "Other",
                        "value": "Other"
                    }
                ]
            },
            "15898_firstName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "firstName",
                "name": "Textbox | First Name",
                "label": "First Name",
                "placeholder": "Enter first name",
                "autoComplete": "given-name",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 2,
                "maxLength": 50,
                "pattern": "^[A-Za-z]{2}[A-Za-z -]*$",
                "hideDisclosure": false,
                "validation": [
                    [
                        "required",
                        "First Name required"
                    ],
                    [
                        "pattern",
                        "^[A-Za-z]{2}[A-Za-z -]*$",
                        "Must start with two letters. Only letters, spaces and hyphens are allowed."
                    ],
                    [
                        "minLength",
                        2,
                        "Min 2 letters"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 letters"
                    ]
                ]
            },
            "15898_lastName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "lastName",
                "name": "Textbox | Last Name",
                "label": "Last Name",
                "placeholder": "Enter last name",
                "autoComplete": "family-name",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 2,
                "maxLength": 50,
                "pattern": "^[A-Za-z]{2}[A-Za-z -]*$",
                "hideDisclosure": false,
                "validation": [
                    [
                        "required",
                        "Last Name required"
                    ],
                    [
                        "pattern",
                        "^[A-Za-z]{2}[A-Za-z -]*$",
                        "Must start with two letters. Only letters, spaces and hyphens are allowed."
                    ],
                    [
                        "minLength",
                        2,
                        "Min 2 letters"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 letters"
                    ]
                ]
            },
            "15898_fullName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "fullName",
                "hideDisclosure": false
            },
            "15897_email": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "email",
                "name": "Textbox | Email Address",
                "label": "Email Address",
                "placeholder": "Enter email address",
                "autoComplete": "email",
                "autoCorrect": "off",
                "spellCheck": "false",
                "maxLength": 50,
                "pattern": "^[a-zA-Z0-9_+-](?:[a-zA-Z0-9._+-])*@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
                "hideDisclosure": false,
                "validation": [
                    [
                        "required",
                        "Email Address required"
                    ],
                    [
                        "pattern",
                        "^[a-zA-Z0-9_+-](?:[a-zA-Z0-9._+-])*@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
                        "Invalid Email Address"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 characters"
                    ]
                ]
            },
            "15900_phone": {
                "type": "inputText",
                "inputType": "tel",
                "fieldId": "phone",
                "name": "Textbox | Phone Number",
                "label": "Phone Number**",
                "labelAlt": "Phone Number",
                "placeholder": "(___) ___-____",
                "inputMask": "(999) 999-9999",
                "autoComplete": "tel-national",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 14,
                "maxLength": 14,
                "pattern": "[(][^01].*",
                "hideDisclosure": false,
                "validation": [
                    [
                        "required",
                        "Phone number is required"
                    ],
                    [
                        "pattern",
                        "[(][^01].*",
                        "Phone area code invalid"
                    ],
                    [
                        "minLength",
                        14,
                        "10-Digit Phone #"
                    ],
                    [
                        "maxLength",
                        14
                    ],
                    [
                        "phone"
                    ]
                ]
            },
            "15900_Phone": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "Phone",
                "hideDisclosure": false
            },
            "15868_occupancy": {
                "type": "radio",
                "fieldId": "occupancy",
                "answerOptions": [
                    {
                        "text": "Investment Property",
                        "value": "Investment Property",
                        "imageUrl": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/6676711.699a51de61e590.53671863.png"
                    },
                    {
                        "text": "Owner Occupied",
                        "value": "Owner Occupied",
                        "imageUrl": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/3458194.699a520a0e7524.72727590.png"
                    }
                ]
            },
            "15862_propertyAddress": {
                "type": "autoAddressMultifield",
                "fieldId": "propertyAddress",
                "required": true,
                "notNY": false,
                "autoComplete": "on",
                "hideDisclosure": false
            },
            "15863_homeValueAmt": {
                "type": "inputText",
                "inputType": "currency",
                "fieldId": "homeValueAmt",
                "questionTitle": "What's the Refinance amount?",
                "includeSlider": false,
                "validation": [
                    [
                        "min",
                        75000,
                        "Min: $75,000"
                    ],
                    [
                        "max",
                        20000000,
                        "Max: $20,000,000"
                    ]
                ]
            },
            "15864_estimateCreditRating": {
                "type": "radio",
                "fieldId": "estimateCreditRating",
                "answerOptions": [
                    {
                        "text": "Excellent (720+)",
                        "value": "Excellent (720+)",
                        "imageUrl": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/22.HCL-Star4.60ee173c638c24.16001568.png"
                    },
                    {
                        "text": "Good (680 – 719)",
                        "value": "Good (680 – 719)",
                        "imageUrl": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/21.HCL-Star3.60ee17372ec1d7.94917995.png"
                    },
                    {
                        "text": "Fair (620 – 679)",
                        "value": "Fair (620 – 679)",
                        "imageUrl": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/20.HCL-Star2.60ee1732e00a27.57474386.png"
                    },
                    {
                        "text": "Poor (580 - 619)",
                        "value": "Poor (580 - 619)",
                        "imageUrl": "https://files.jotform.com/jufs/Roberts_Ryan_ryan%2Fform_files%2F19.HCL-Star1.60ee172e1996d5.15114805.png?md5=JaKuL58UaX5RA_D0ulnOpg&expires=1771605309"
                    },
                    {
                        "text": "Below < 580",
                        "value": "Below < 580",
                        "imageUrl": "https://files.jotform.com/jufs/Roberts_Ryan_ryan%2Fform_files%2F19.HCL-Star1.60ee172e1996d5.15114805.png?md5=JaKuL58UaX5RA_D0ulnOpg&expires=1771605309"
                    }
                ]
            },
            "15867_liquidity": {
                "type": "radio",
                "fieldId": "liquidity",
                "answerOptions": [
                    {
                        "text": "No liquidity",
                        "value": "No liquidity"
                    },
                    {
                        "text": "Less than $25k",
                        "value": "Less than $25k"
                    },
                    {
                        "text": "$25k to $50k",
                        "value": "$25k to $50k"
                    },
                    {
                        "text": "$50k to $100k",
                        "value": "$50k to $100k"
                    },
                    {
                        "text": "More than $100k",
                        "value": "More than $100k"
                    },
                    {
                        "text": "Other",
                        "value": "Other"
                    }
                ]
            },
            "15866_firstName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "firstName",
                "name": "Textbox | First Name",
                "label": "First Name",
                "placeholder": "Enter first name",
                "autoComplete": "given-name",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 2,
                "maxLength": 50,
                "pattern": "^[A-Za-z]{2}[A-Za-z -]*$",
                "hideDisclosure": false,
                "validation": [
                    [
                        "required",
                        "First Name required"
                    ],
                    [
                        "pattern",
                        "^[A-Za-z]{2}[A-Za-z -]*$",
                        "Must start with two letters. Only letters, spaces and hyphens are allowed."
                    ],
                    [
                        "minLength",
                        2,
                        "Min 2 letters"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 letters"
                    ]
                ]
            },
            "15866_lastName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "lastName",
                "name": "Textbox | Last Name",
                "label": "Last Name",
                "placeholder": "Enter last name",
                "autoComplete": "family-name",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 2,
                "maxLength": 50,
                "pattern": "^[A-Za-z]{2}[A-Za-z -]*$",
                "hideDisclosure": false,
                "validation": [
                    [
                        "required",
                        "Last Name required"
                    ],
                    [
                        "pattern",
                        "^[A-Za-z]{2}[A-Za-z -]*$",
                        "Must start with two letters. Only letters, spaces and hyphens are allowed."
                    ],
                    [
                        "minLength",
                        2,
                        "Min 2 letters"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 letters"
                    ]
                ]
            },
            "15866_fullName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "fullName",
                "hideDisclosure": false
            },
            "15865_email": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "email",
                "name": "Textbox | Email Address",
                "label": "Email Address",
                "placeholder": "Enter email address",
                "autoComplete": "email",
                "autoCorrect": "off",
                "spellCheck": "false",
                "maxLength": 50,
                "pattern": "^[a-zA-Z0-9_+-](?:[a-zA-Z0-9._+-])*@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
                "hideDisclosure": false,
                "validation": [
                    [
                        "required",
                        "Email Address required"
                    ],
                    [
                        "pattern",
                        "^[a-zA-Z0-9_+-](?:[a-zA-Z0-9._+-])*@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
                        "Invalid Email Address"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 characters"
                    ]
                ]
            },
            "15869_phone": {
                "type": "inputText",
                "inputType": "tel",
                "fieldId": "phone",
                "name": "Textbox | Phone Number",
                "label": "Phone Number**",
                "labelAlt": "Phone Number",
                "placeholder": "(___) ___-____",
                "inputMask": "(999) 999-9999",
                "autoComplete": "tel-national",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 14,
                "maxLength": 14,
                "pattern": "[(][^01].*",
                "disclosure": "**By entering my phone number above, I agree to receive recurring automated text messages at the phone number provided. Consent is not a condition to purchase. Msg &amp; data rates may apply. Msg frequency varies.",
                "hideDisclosure": true,
                "validation": [
                    [
                        "required",
                        "Phone number is required"
                    ],
                    [
                        "pattern",
                        "[(][^01].*",
                        "Phone area code invalid"
                    ],
                    [
                        "minLength",
                        14,
                        "10-Digit Phone #"
                    ],
                    [
                        "maxLength",
                        14
                    ],
                    [
                        "phone"
                    ]
                ]
            },
            "15869_Phone": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "Phone",
                "disclosure": "**By entering my phone number above, I agree to receive recurring automated text messages at the phone number provided. Consent is not a condition to purchase. Msg &amp; data rates may apply. Msg frequency varies.",
                "hideDisclosure": true
            },
            "loanPurpose": {
                "type": "radio",
                "fieldId": "loanPurpose",
                "answerOptions": [
                    {
                        "value": "purchase",
                        "text": "Purchasing",
                        "customIconImage": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/8858068.699a5147246524.12494439.png",
                        "id": 15839
                    },
                    {
                        "value": "refinance",
                        "text": "Refinancing",
                        "customIconImage": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/8176506.699a50fa558561.50000586.png",
                        "id": 15840
                    },
                    {
                        "value": "cashout",
                        "text": "Cashing Out",
                        "customIconImage": "https://www.jotform.com/uploads/Roberts_Ryan_ryan/form_files/cash.65a02a1ede9f25.33021495.png",
                        "id": 15837
                    }
                ]
            }
        },
        "introDescription": "Let us know your goal so we can find the right fit.",
        "customIntroQuestion": "Are you buying, refinancing, or pulling cash out?",
        "pageSpecificDisclosures": "",
        "_rid": "cUFDANRpTdkPAAAAAAAAAA==",
        "_self": "dbs/cUFDAA==/colls/cUFDANRpTdk=/docs/cUFDANRpTdkPAAAAAAAAAA==/",
        "_etag": "\"2e00ef6c-0000-4d00-0000-69a7542e0000\"",
        "_attachments": "attachments/",
        "_ts": 1772573742
    }
};
